export default "__VITE_ASSET__32cf3ee6__"